import { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useIsMobile } from "../../hooks";
import styles from "./CategoryHeaderDescription.css";

const CategoryHeaderDescription = ({ viewport, description, device }) => {
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = useState(false);
  const descriptionContainerId = `descriptionContainer-${device || "default"}`;

  useEffect(() => {
    setExpanded(false);
  }, [isMobile]);

  const onClick = useCallback(() => {
    setExpanded((prev) => !prev);
  }, [viewport]);

  if (!description) {
    return null;
  }
  const deviceClass =
    device === "mobileOnly" ? styles.mobileOnly : styles.desktopOnly;

  return (
    <div className={deviceClass}>
      <button
        className={styles.button}
        aria-controls={descriptionContainerId}
        aria-expanded={expanded}
        onClick={onClick}
      >
        <div className={styles.container} id={descriptionContainerId}>
          <p
            className={classNames(styles.shortenedDescription, {
              [styles.hide]: expanded,
            })}
          >
            {description}
          </p>
          {!expanded && description && (
            <span className={styles.ellipsis} aria-hidden="true">
              ...
            </span>
          )}
          <noscript className={styles.hiddenDescription}>
            {description}
          </noscript>
          <p
            aria-hidden={!expanded}
            className={classNames(styles.hide, {
              [styles.expanded]: expanded,
            })}
          >
            {description}
          </p>
          <div
            className={classNames(styles.icon, {
              [styles.iconUp]: expanded,
            })}
          />
        </div>
      </button>
    </div>
  );
};

CategoryHeaderDescription.propTypes = {
  description: PropTypes.string,
  viewport: PropTypes.string.isRequired,
  device: PropTypes.string,
};

export default CategoryHeaderDescription;
